import repository from '@/utils/repository';

export default {
    changePassWordMNG: (data) => {
        return repository.post(`/move/change-password-mng`, {
            ...data
        });
    },
    changePassWordCUS: (data) => {
        return repository.post(`/move/change-password-cus`, {
            ...data
        });
    }
    // ,
    // getImage: (path) => {
    //     // const parts = path.split(/[/\\]+/);
    //     let parts = path == null ? [''] : path.split(/[/\\]+/);
    //     let fileName = parts[parts.length - 1];
    //     return repository.get(`move/preview-image/6/${fileName}`, {
    //         responseType: 'blob'
    //     });
    // }
};
